var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.hasSelectedTeam)?_c('router-view'):_c('Loader',{attrs:{"is-loading":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }